import classNames from 'classnames';

interface IProps {
  className?: string;
}
export const StoryTileSkeleton = ({ className }: IProps) => {
  return (
    <article className={classNames('animate-pulse', className)}>
      <div className="flex w-full basis-full flex-row items-center justify-start pb-3">
        <div className="mr-2 h-[30px] w-[30px] flex-shrink-0 rounded-full bg-black/10 dark:bg-white/10" />

        <div className="hidden w-[1px] flex-grow flex-col justify-center gap-1 pr-2 sm:flex">
          <div className="h-3 w-2/3 rounded bg-black/10 dark:bg-white/10" />
          <div className="h-2 w-1/3 rounded bg-black/10 dark:bg-white/10" />
        </div>

        <div className="ml-auto h-2 w-10 flex-shrink-0 rounded bg-black/10 dark:bg-white/10" />
      </div>

      <div className="aspect-[9/16] w-full rounded-xl bg-black/10 dark:bg-white/10" />
    </article>
  );
};
